<!--查询招投标-->
<template>
  <div class="search-bidding-container">
    <header-index/>
    <div class="search-bidding-content">
      <div class="search-bidding-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>招投标</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-bidding-top">
        <p class="search-bidding-title">查询招投标</p>
        <el-input placeholder="请输入项目名称、企业名称、编号等" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="gteBiddingInfo">
          <el-button type="danger" slot="append" @click="gteBiddingInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="search-bidding-info">
        <div class="search-bidding-search-menu">
          <span>最新招投标</span>
          <div>
            <el-select v-model="region" placeholder="请选择" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全国'" :value="''"/>
              <el-option v-for="item1 in provincialCode" :label="item1.name" :value="item1.name"/>
            </el-select>
            <el-select v-model="noticeType" placeholder="全部招标" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全部招标'" :value="''"/>
              <el-option v-for="item in noticeTypeItem" :label="item.name" :value="item.name"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份" style="width: 170px"/>
          </div>
        </div>
        <div class="search-bidding-list">
          <div v-for="info of biddingInfo" class="search-bidding-list-item" @click="Details(info)">
            <p class="search-bidding-small-title">{{ info.title }}</p>
            <p style="padding-bottom: 10px;"><i class="bidding-status">{{info.announcementType}}</i></p>
            <p>
              <span class="search-bidding-gray">项目编号：</span>
              <span class="search-bidding-black">{{ info.projectNo || '-'}}</span>
              <span class="search-bidding-gray">招采单位：</span>
              <span class="search-bidding-black">{{ info.biddingCompany || '-'}}</span>
              <span class="search-bidding-gray">代理单位：</span>
              <span class="search-bidding-black">{{ info.biddingAgency || '-' }}</span>
            </p>
            <p>
              <span class="search-bidding-gray">预算金额：</span>
              <span class="search-bidding-black">{{ info.budgetAmount || '-'}}</span>
              <span class="search-bidding-gray">联系方式：</span>
              <span class="search-bidding-black">{{ info.plaintiff || '-'}}</span>
            </p>
            <p>
              <span class="search-bidding-gray">发布时间：</span>
              <span class="search-bidding-black">{{ info.publicationDate || '-'}}</span>
              <span class="search-bidding-gray">投标截止时间：</span>
              <span class="search-bidding-black">{{ info.dateHearing || '-'}}</span>
            </p>
          </div>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {
  searchBiddingByKeyword,
  getRegionGroup,
  getAnnouncementType
} from '@/api/enterprise_searchApi'

export default {
  name: "bidding",
  components: {Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      keyword: '',
      cityList: {},
      cid: 0,
      year: '',
      region: '',
      cityJson: cityJson,
      provincialCode: [],
      biddingInfo: [],
      noticeType: '',
      noticeTypeItem: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.gteBiddingInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.gteBiddingInfo();
      }
    },
    noticeType(newVal, oldVal) {
      if (newVal != oldVal) {
        this.gteBiddingInfo();
      }
    },
  },
  methods: {
    /*获取招投标数据*/
    gteBiddingInfo() {
      searchBiddingByKeyword({
        announcementType: this.noticeType,
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        publicationDate: this.year,
        region: this.region
      }).then(res => {
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.biddingInfo=res.content.rows;
          console.log(res);
        }
      })
    },
    /*获取公告类型*/
    getNoticeType(){
      getAnnouncementType().then(res=>{
        if (res.code==200){
          this.noticeTypeItem=res.content;
        }
      })
    },
    /*获取招投标公告地域分布*/
    getBiddingNoticeArea(){
      getRegionGroup().then(res=>{
        if (res.code==200){
          this.provincialCode=res.content;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.gteBiddingInfo();
    },
    Details(info){
      let routeData = this.$router.resolve({
        name: "enterpriseBiddingDetails",
        path: '/enterpriseSearch/biddingDetails',
        query: {id:info.id}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getNoticeType();
    this.getBiddingNoticeArea();
    this.gteBiddingInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.search-bidding-container >>> .search-bidding-content .search-bidding-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-top input::-webkit-input-placeholder {
  color: #333333;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-top .el-icon-search {
  font-size: 19px;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__inner a,
.search-bidding-container >>> .search-bidding-content .search-bidding-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.search-bidding-container >>> .search-bidding-content .search-bidding-info .search-bidding-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
</style>
<style scoped lang="scss">
.search-bidding-container {
  background: #E7E9F5;
  .search-bidding-content {
    .search-bidding-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }
    .search-bidding-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 400px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .search-bidding-title {
        color: #ffffff;
        margin: 100px 0 60px;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 100px 0px 60px;
        font-weight: bold;
      }
    }
    .search-bidding-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .search-bidding-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }
      .search-bidding-list {
        .search-bidding-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;
          .search-bidding-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 10px;
          }
          .search-bidding-gray {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .search-bidding-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
            padding-right: 80px;
          }
          .bidding-status{
            color: #FE273B;
            font-style: normal;
            font-size: 12px;
            padding: 5px 15px;
            background: #FFEFF0;
            border-radius: 4px;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>